import { useState, useEffect, useRef } from 'react';

/**
 * Hook to track container width and determine compact mode
 * @param {number} threshold - Width threshold below which compact mode activates (default: 600px)
 * @returns {{ containerRef: React.RefObject, isCompact: boolean, containerWidth: number }}
 */
export function useContainerWidth(threshold = 600) {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [isCompact, setIsCompact] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const width = entry.contentRect.width;
                const shouldBeCompact = width < threshold;

                setContainerWidth(width);
                setIsCompact(shouldBeCompact);
            }
        });

        resizeObserver.observe(container);

        return () => {
            resizeObserver.disconnect();
        };
    }, [threshold]);

    return { containerRef, isCompact, containerWidth };
}
